<template>
  <div id="testimonials">
    <h1>TESTIMONIALS</h1>
    <div id="article" v-for="review in reviews" :key="review">
      <div id="testimonial">
        <p style="white-space:pre-wrap;">{{ review.testimonial }}</p>
      </div>
      <div id="author">
        <h3>{{ review.author }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav-Testimonials',
  components: {
    
  },
  data() {
    return {
      reviews: [
        {
          author: "H. Price, Coventry",
          testimonial: "A Real Doctor with a Golden Heart\nWhen I met Dr Sun in September 2015, it was the reward of several months of desperate research for alternative venues for treatment. I wanted to be seen by a properly qualified Chinese medicine practitioner.\nI was in such a state of poor health. My body was unable to cope with any western conventional medication.\nThe severe arthritic pains in my hands and feet had taken toll on me, and the severe bleeding caused by my ulcerative colitis made it impossible for me to convince my consultants that my bowel was worth keeping. The treatment for my ulcerative colitis, Asacol and Pentasa, seem to be the trigger for my severe inflammatory arthritis.\nDr Sun listened to me and checked my pulse then she prepared a mixture of herbs for me to take for a week. I was not then keen on acupuncture or massage and I resolved to the herbal treatment only at the time.\nAfter two weeks, my pains started to reduce and the bleeding almost stopped. A month later, I was able to use my hands and able to walk with no walking stick. It felt so strange to me to be off my western medication, only taking Dr Sun’s herbal preparation and yet feeling so healthy for the first time in my life without having to lose my bowel or to be pumped with methotrexate or similar damaging drugs.\nI had an unfortunate relapse in January following bad flu when I was overseas and I ran out of the herbal preparation for three weeks.\nSince early February, I have been back under Dr Sun’s care, including 7 sessions of acupuncture, cupping and medical massage. And yes, I am getting better. The hardest part has not having to drive for over an hour to get to Dr Sun’s clinic once or twice a week, but it is the medical massage… yes… very painful, but after every session, my pains were reduced.\nDr Sun said I am going to be better after two to three more weeks and, I believe that because, from personal experience, I do trust what Dr Sun does and what she says."
        },
        {
          author: "Denise Priest",
          testimonial: "Great to have cupping and Chinese massage along with acupuncture. Dr Sun listens and helps. I trusted her and now feel so much better. 18 months of physiotherapy with no improvement - and only 4 weeks of treatment here and I am so very much better. Excellent!"
        },
        {
          author: "Naelah Salem",
          testimonial: "Dr Sun has offered me the greatest of care and attention to my health.\nI suffered from regular headaches and jaundice, and through 3 accupunter and massage sessions my health has improved immensely. \nA highly recommended place to go if you suffer from any health issues. I am so luckly to have been recommended Dr Sun through friends, she has shown to be a well experienced and caring practitioner who had paid careful attention to my individual needs.\nI now attend weekly and I always look forward to my sessions because I know I will end the session relaxed and calm and revitalised!!"
        }
      ]
    }
  }
}
</script>

<style>
#testimonial {
  text-align: left;
}
#article {
  padding-top: 15px;
}
#author{
  text-align: left;
  padding-bottom: 25px;
}
@media only screen and (min-width: 320px) {
  #testimonials {
    padding-top: 15px;
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media only screen and (min-width: 1000px) {
  #testimonials {
    padding-left: 15%;
    padding-right: 15%;
  }
}

</style>
